import React, { Component } from 'react';

import { telehealthService } from '../../../_services/telehealth.service';

import SynchronousVideo from '../../../_services/Video/';
import MuteButton from './Components/MuteButton.js';
import EndCallButton from './Components/EndCallButton.js';
import ShareScreenButton from './Components/ShareScreenButton.js';

import './style.css';

class Video extends Component {
  constructor(props) {
    super(props);

    this.state = {
      messageLabel: 'Connecting'
    }

    this.handleMessage = this.handleMessage.bind(this);
  }

  componentDidMount() {
    const localMediaContainer = document.getElementById('local-media');
    const remoteMediaContainer = document.getElementById('remote-media');

    this.synchronousVideo = new SynchronousVideo(localMediaContainer, remoteMediaContainer);
    this.synchronousVideo.subscribe(this.handleMessage);

    // get token
    telehealthService.getVideoToken(this.props.match.params.id)
      .then(response => {
        this.synchronousVideo.connect(response.token);
      })
      .catch(error => {
        alert('A video connect could not be establish at this time. Please try again later.');
      });
  }

  handleMessage(message) {
    this.setState({
      messageLabel: message
    });
  }

  handleEndCall() {
    this.synchronousVideo.endCall();

    window.close();
  }

  render() {
    return (
      <div className="row" id="telemedicineVideo">
        <div className="col-12">
          <div id="remote-media" className="text-center"></div>

          <div id="telemedicineVideo--links" className="row">
            <div className="col-12">
              <p
                style={{ backgroundColor: 'rgba(0, 0, 0, .3)', color: '#fff', padding: '5px', margin: '0 0 10px 0', textAlign: 'center' }}
              >{this.state.messageLabel}</p>
            </div>


            <div className="row ml-5">
              <div className="col-4">
                <MuteButton handleMute={(isMuted) => this.synchronousVideo.handleMute(isMuted)} />
              </div>
              <div className="col-4">
                <ShareScreenButton
                  publishScreenCapture={(track) => this.synchronousVideo.publishScreenCapture(track)}
                  unpublishScreenCapture={(track) => this.synchronousVideo.unpublishScreenCapture(track)}
                />
              </div>
              <div className="col-4">
                <EndCallButton handleEndCall={() => this.handleEndCall()} />
              </div>
            </div>
          </div>

          <div className="col-12" id="local-media" style={{ width: '150px', height: '113px' }}></div>
        </div>
      </div>
    )
  }
}

export default Video;